import React from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { Icon } from '@doxyme/ui';
import { Button, ButtonType } from './button';
import { NotificationType, } from '../store/features/notification/types';
import { hideNotification } from '../store/features/notification/action-creators';
import './notification-top.style.scss';
const getNotificationIcon = (type) => {
    switch (type) {
        case NotificationType.SUCCESS:
            return 'checkmark-filled';
        case NotificationType.ERROR:
            return 'exclamation';
        default:
            return 'question-mark';
    }
};
export const NotificationTop = () => {
    const notification = useSelector((state) => state.notification);
    const dispatch = useDispatch();
    const icon = getNotificationIcon(notification.type);
    const handleClick = (action) => {
        dispatch(hideNotification());
        action.callback?.();
    };
    const notificationClass = classNames('notification', {
        'notification--visible': notification.isVisible,
        [`notification--${notification.type}`]: notification.type,
    });
    const notificationMessageClass = classNames('notification-message');
    const notificationActionsClass = classNames('notification-actions');
    return (<div className={notificationClass}>
      <Icon name={icon} size="small"/>
      <div className={notificationMessageClass}>
        {notification.text}
      </div>
      <div className={notificationActionsClass}>
        {notification.actions.map((action, index) => <Button type={ButtonType.LINK} key={index} onClick={() => handleClick(action)}>{action.label}</Button>)}
      </div>
    </div>);
};
